<div class="gauge-container">

    <img
      src="assets/img/acid-conc-web.svg"
      alt="Image Label"
      class="centered-image"
    />
  </div>
  